//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

/**
 * The json payload for content assessment options
 */
export interface ContentAssessmentOptions {
    /**
     * The topic for content assessment.
     */
    topic: string;
}
